import { Container } from '@xo-union/tk-component-grid';
import { H4 } from '@xo-union/tk-ui-typography';
import React, { ReactNode } from 'react';

import styles from './contentSection.scss';

interface Props {
  name: string;
  children: ReactNode;
  inlineChild?: ReactNode;
  as?: string; // What to render the name as, heading-wise
  className?: string;
}

export const ContentSection: React.FC<Props> = ({ name, inlineChild, children, as, className = '' }) => (
  <div className={`${styles.container} ${className}`}>
    <div className={styles.titleContainer}>
      <H4 className={styles.title} as={as}>
        {name}
      </H4>
      {inlineChild && <div>{inlineChild}</div>}
    </div>
    <Container>{children}</Container>
  </div>
);
